import { useQueryClient } from "@tanstack/react-query"
import {
	getPlatformAdminslistPlatformAdminsQueryKey,
	usePlatformAdminscreatePlatformAdmin,
	usePlatformAdminslistPlatformAdmins,
	usePlatformAdminsupdatePlatformAdmin,
} from "@/shared/api/generated/platform-admins/platform-admins"
import { PlatformAdminslistPlatformAdminsResponse } from "@/shared/api/generated/platform-admins/platform-admins.zod"
import type {
	PlatformAdminCreateRequest,
	PlatformAdminUpdateRequest,
} from "@/shared/api/generated/types/platform-admins"
import { validateSuccessResponse } from "@/shared/lib/zod-validation-helpers"

const STALE_MS = 30_000

export function usePlatformUserList() {
	return usePlatformAdminslistPlatformAdmins({
		query: {
			retry: false,
			staleTime: STALE_MS,
			select(data) {
				return validateSuccessResponse(
					PlatformAdminslistPlatformAdminsResponse,
					data,
				)
			},
		},
	})
}

export function usePlatformUserMutations() {
	const queryClient = useQueryClient()
	const invalidate = async () => {
		await queryClient.invalidateQueries({
			queryKey: getPlatformAdminslistPlatformAdminsQueryKey(),
		})
	}

	const createUser = usePlatformAdminscreatePlatformAdmin({
		mutation: { onSuccess: () => invalidate() },
	})
	const updateUser = usePlatformAdminsupdatePlatformAdmin({
		mutation: { onSuccess: () => invalidate() },
	})

	return {
		createUser: (data: PlatformAdminCreateRequest) =>
			createUser.mutateAsync({ data }),
		updateUser: (id: string, data: PlatformAdminUpdateRequest) =>
			updateUser.mutateAsync({ id, data }),
		isSaving: createUser.isPending || updateUser.isPending,
	}
}
